import { makeStyles } from '@material-ui/core';

const useBgvTrackingStyles = makeStyles(() => ({
    container: {
        height: 'calc(100vh - 90px)',
        overflow: 'auto',
    },
    header: {
        padding: '20px 24px 0 24px',
    },
    title: {
        fontSize: '1.25rem',
        fontWeight: 700,
        color: '#14112D',
    },
    subTitle: {
        fontSize: '0.875rem',
        color: 'rgba(20, 17, 45, 0.60)',
        marginTop: 2,
    },
    tabs: {
        padding: '0 24px',
        borderBottom: '1px solid #EBEDF8',
        '& .MuiTab-root': {
            textTransform: 'none',
            fontWeight: 600,
            minWidth: 120,
        },
    },
    filters: {
        padding: '16px 24px',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: 12,
    },
    select: {
        minWidth: 180,
    },
    cards: {
        padding: '0 24px 16px 24px',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
        gap: 12,
    },
    card: {
        padding: '14px 16px',
        borderRadius: 10,
        border: '1px solid #EBEDF8',
        cursor: 'pointer',
        transition: 'box-shadow 120ms ease, border-color 120ms ease',
        '&:hover': {
            boxShadow: '0 2px 10px rgba(20, 17, 45, 0.08)',
        },
    },
    cardActive: {
        borderColor: '#4F46E5',
        boxShadow: '0 0 0 1px #4F46E5',
    },
    cardLabel: {
        fontSize: 12,
        fontWeight: 600,
        color: 'rgba(20, 17, 45, 0.60)',
        display: 'flex',
        alignItems: 'center',
        gap: 6,
    },
    cardValue: {
        fontSize: 26,
        fontWeight: 700,
        color: '#14112D',
        marginTop: 4,
        fontVariantNumeric: 'tabular-nums',
    },
    dot: {
        width: 8,
        height: 8,
        borderRadius: '50%',
        display: 'inline-block',
    },
    tableSection: {
        padding: '0 24px',
    },
    tableContainer: {
        border: '1px solid #EBEDF8',
        borderRadius: 10,
        maxHeight: 'calc(100vh - 420px)',
        minHeight: 240,
    },
    headCell: {
        fontWeight: 700,
        fontSize: 12,
        color: '#525050',
        backgroundColor: '#F6F7F9',
        whiteSpace: 'nowrap',
    },
    cell: {
        fontSize: 13,
        color: '#14112D',
        whiteSpace: 'nowrap',
    },
    row: {
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: '#F8F9FD',
        },
    },
    muted: {
        fontSize: 12,
        color: 'rgba(20, 17, 45, 0.55)',
    },
    chip: {
        fontWeight: 600,
        fontSize: 12,
        height: 24,
    },
    backfill: {
        padding: '16px 24px',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(360px, 1fr))',
        gap: 16,
    },
    panel: {
        padding: 20,
        borderRadius: 10,
        border: '1px solid #EBEDF8',
    },
    stepTitle: {
        fontSize: 13,
        fontWeight: 700,
        color: '#14112D',
        margin: '20px 0 8px',
    },
    panelTitle: {
        fontSize: 15,
        fontWeight: 700,
        color: '#14112D',
        marginBottom: 4,
    },
    stat: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '6px 0',
        fontSize: 13,
        borderBottom: '1px dashed #EBEDF8',
    },
    statValue: {
        fontWeight: 700,
        fontVariantNumeric: 'tabular-nums',
    },
}));

export default useBgvTrackingStyles;
